import React from "react";
import { Link } from "react-router-dom";
import { loginlog } from "../Constant/Index";

function Forgorpassword() {
  return (
    <>
      {/* Forgot password Section  */}
      <section className="login_sec overflow-hidden">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="auth_form">
              {/* <div className="mobileLogo">
                <Link to="/">
                  <figure>
                    <img src={logo} alt="weblogo" className="img-fluid" />
                    dddd
                  </figure>
                </Link>
              </div> */}
              <div className="heading_wrapper">
                <div className="webLogo">
                  <Link to="/">
                    <figure>
                      <img src={loginlog} alt="weblogo" className="img-fluid" />
                    </figure>
                  </Link>
                </div>
                <p className="tagline secondary-color font-weight-bold">
                  Powerful Hand
                </p>

                <h2 className="title primary-color">Forgot Password</h2>
                <p className="primary-color font-weight-meduim">
                  Enter the email address associated with your account and we
                  will send you a password reset link.
                </p>
              </div>
              <form>
                <div className="form-group">
                  <input
                    required
                    type="text"
                    placeholder="Email"
                    name="email"
                    className="form-control"
                  />
                </div>
               
                <div className="button-group">
               <Link to="/otp">   <button className="milkyBtn w-100">Continue</button></Link>
                </div>
               
              </form>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="showcase_column">
              {/* <div className="webLogo">
                <Link to="/">
                  <figure>
                    <img src={loginimg} alt="weblogo" className="img-fluid" />
                  </figure>
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      {/* ======================       */}
    </>
  );
}

export default Forgorpassword;
